"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const root_1 = require("react-hot-loader/root");
const master_page_1 = require("@pages/master-page");
const external_1 = require("./store/external");
const withHttpError_1 = require("./hoc/withHttpError");
const withInitialData_1 = require("./hoc/withInitialData");
const withBlockTracker_1 = require("./hoc/withBlockTracker");
const withAccountConfirmation_1 = require("./hoc/withAccountConfirmation");
const withListener_1 = require("./hoc/withListener");
const App = () => (React.createElement(react_router_dom_1.BrowserRouter, null,
    React.createElement(React.StrictMode, null,
        React.createElement(external_1.Updaters, null),
        React.createElement(master_page_1.MasterPage, null))));
exports.default = (0, withListener_1.withListenerProvider)((0, withHttpError_1.withHttpError)((0, withBlockTracker_1.withBlockTracker)((0, withInitialData_1.withInitialData)((0, withAccountConfirmation_1.withAccountConfirmation)((0, root_1.hot)(App))))));
